import {
  ApplicationConfig, importProvidersFrom,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';

import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { KeycloakService } from 'keycloak-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { authInterceptor } from './auth/auth-interceptor';
import { DEFAULT_LANG } from './services/language';

export function HttpLoaderFactory(backend: HttpBackend) {
  return new MultiTranslateHttpLoader(
    backend, ['/i18n/en/common.json']
  );
}


export const appConfig: ApplicationConfig = {
  providers: [

    provideEnvironmentNgxMask(),

    provideBrowserGlobalErrorListeners(),


    provideHttpClient(
      withFetch(),

      // adiciona o Bearer Token Mobile
      withInterceptors([
        authInterceptor
      ])
    ),


    provideRouter(routes),


    KeycloakService,

    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: DEFAULT_LANG,
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },

      }),
    ),

  ],
};